// import JUNIPER_BG from "../assets/coverpageThemeThumbnails/juniper.png";
import DEFAULT_BG from "../assets/coverpageThemeThumbnails/default.png";
import THUMB_BUTTERY from "../assets/coverpageThemeThumbnails/thumbnail_buttery.jpg";
import THUMB_CERULEAN from "../assets/coverpageThemeThumbnails/thumbnail_cerulean.jpg";
import THUMB_ETHER from "../assets/coverpageThemeThumbnails/thumbnail_ether.jpg";
import THUMB_GLOW from "../assets/coverpageThemeThumbnails/thumbnail_glow.jpg";
import THUMB_LUSH from "../assets/coverpageThemeThumbnails/thumbnail_lush.jpg";
import THUMB_MAHOGANY from "../assets/coverpageThemeThumbnails/thumbnail_mahogany.jpg";
import THUMB_MELLOW from "../assets/coverpageThemeThumbnails/thumbnail_mellow.jpg";
import THUMB_OLIVE from "../assets/coverpageThemeThumbnails/thumbnail_olive.jpg";
import THUMB_PERFECTION from "../assets/coverpageThemeThumbnails/thumbnail_perfection.jpg";
import THUMB_SMOKEY from "../assets/coverpageThemeThumbnails/thumbnail_smokey.jpg";
import THUMB_TITIAN from "../assets/coverpageThemeThumbnails/thumbnail_titian.jpg";
import THUMB_YOUTH from "../assets/coverpageThemeThumbnails/thumbnail_youth.jpg";
import THUMB_ALLURE from "../assets/coverpageThemeThumbnails/thumbnail_allure.jpg";
import THUMB_CANARY from "../assets/coverpageThemeThumbnails/thumbnail_canary.jpg";
import THUMB_CELESTIAL from "../assets/coverpageThemeThumbnails/thumbnail_celestial.jpg";
import THUMB_FUSCHIA from "../assets/coverpageThemeThumbnails/thumbnail_fuschia.jpg";
import THUMB_JUNIPER from "../assets/coverpageThemeThumbnails/thumbnail_juniper.jpg";
import THUMB_LILAC from "../assets/coverpageThemeThumbnails/thumbnail_lilac.jpg";
import THUMB_SCARLET from "../assets/coverpageThemeThumbnails/thumbnail_scarlet.jpg";
// import COVERPAGE_BACKGROUND_IMAGE_STREET from "../assets/cover-page-image-template-street.jpg";
// import COVERPAGE_BACKGROUND_IMAGE_LAPTOP from "../assets/cover-page-image-template-laptop.jpg";
// import COVERPAGE_BACKGROUND_IMAGE_SHAPES from "../assets/cover-page-image-template-shapes.jpg";
// import COVERPAGE_BACKGROUND_IMAGE_ABSTRACT from "../assets/cover-page-image-template-abstract.jpg";

const THEME_THUMBNAILS = [
  {
    id: "default",
    label: "Default",
    thumbnail: DEFAULT_BG,
    data: {
      background: "#fff",
      colorTransparency: 0.0,
      backgroundImage: "",
      imageTransparency: 0.1,
      imagePosition: "center right",
      appliedTheme: "Default",
    },
  },
  {
    id: "juniper",
    label: "Juniper",
    thumbnail: THUMB_JUNIPER,
    data: {
      background: "#184651",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 0.9,
      imagePosition: "center right",
      appliedTheme: "Juniper",
    },
  },
  {
    id: "lilac",
    label: "Lilac",
    thumbnail: THUMB_LILAC,
    data: {
      background: "#5a3d68",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-laptop.jpg",
      imageTransparency: 1.0,
      imagePosition: "center right",
      appliedTheme: "Lilac",
    },
  },
  {
    id: "canary",
    label: "Canary",
    thumbnail: THUMB_CANARY,
    data: {
      background: "#1cb5c0",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1,
      imagePosition: "top center",
      appliedTheme: "Canary",
    },
  },
  {
    id: "celestial",
    label: "Celestial",
    thumbnail: THUMB_CELESTIAL,
    data: {
      background: "#37bc72",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1.0,
      imagePosition: "center right",
      appliedTheme: "Celestial",
    },
  },
  {
    id: "allure",
    label: "Allure",
    thumbnail: THUMB_ALLURE,
    data: {
      background: "#35304B",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      imagePosition: "center right",
      appliedTheme: "Allure",
    },
  },
  {
    id: "scarlet",
    label: "Scarlet",
    thumbnail: THUMB_SCARLET,
    data: {
      background: "#00aab5",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Scarlet",
      imagePosition: "center right",
    },
  },
  {
    id: "fuschia",
    label: "Fuschia",
    thumbnail: THUMB_FUSCHIA,
    data: {
      background: "#e3e1e0",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Fuschia",
      imagePosition: "center right",
    },
  },
  {
    id: "titian",
    label: "Titian",
    thumbnail: THUMB_TITIAN,
    data: {
      background: "#202761",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1,
      appliedTheme: "Titian",
      imagePosition: "center center",
    },
  },
  {
    id: "smokey",
    label: "Smokey",
    thumbnail: THUMB_SMOKEY,
    data: {
      background: "#f9581e",
      colorTransparency: 0.6,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Smokey",
      imagePosition: "center right",
    },
  },
  {
    id: "mellow",
    label: "Mellow",
    thumbnail: THUMB_MELLOW,
    data: {
      background: "#081623",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 0.8,
      appliedTheme: "Mellow",
      imagePosition: "center right",
    },
  },
  {
    id: "cerulean",
    label: "Cerulean",
    thumbnail: THUMB_CERULEAN,
    data: {
      background: "#5a3d68",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Cerulean",
      imagePosition: "center right",
    },
  },
  {
    id: "buttery",
    label: "Buttery",
    thumbnail: THUMB_BUTTERY,
    data: {
      background: "#0014c6",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-laptop.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Buttery",
      imagePosition: "center right",
    },
  },
  {
    id: "perfection",
    label: "Perfection",
    thumbnail: THUMB_PERFECTION,
    data: {
      background: "#ffef64",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Perfection",
      imagePosition: "center right",
    },
  },
  {
    id: "mahogany",
    label: "Mahogany",
    thumbnail: THUMB_MAHOGANY,
    data: {
      background: "#ac2102",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Mahogany",
      imagePosition: "center center",
    },
  },
  {
    id: "youth",
    label: "Youth",
    thumbnail: THUMB_YOUTH,
    data: {
      background: "#9dbb24",
      colorTransparency: 0.6,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Youth",
      imagePosition: "center right",
    },
  },
  {
    id: "lush",
    label: "Lush",
    thumbnail: THUMB_LUSH,
    data: {
      background: "#346d06",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 0.8,
      appliedTheme: "Lush",
      imagePosition: "center right",
    },
  },
  {
    id: "ether",
    label: "Ether",
    thumbnail: THUMB_ETHER,
    data: {
      background: "#bbd2ff",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Ether",
      imagePosition: "top right",
    },
  },
  {
    id: "glow",
    label: "Glow",
    thumbnail: THUMB_GLOW,
    data: {
      background: "#e1b0b0",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Glow",
      imagePosition: "center right",
    },
  },
  {
    id: "olive",
    label: "Olive",
    thumbnail: THUMB_OLIVE,
    data: {
      background: "#647b69",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Olive",
      imagePosition: "center right",
    },
  },
];

// eslint-disable-next-line import/prefer-default-export
export { THEME_THUMBNAILS };



// WEBPACK FOOTER //
// ./src/constants/coverpageTemplates.js